import { render, staticRenderFns } from "./GirlMagicBook.vue?vue&type=template&id=03ad9376&scoped=true&"
import script from "./GirlMagicBook.vue?vue&type=script&lang=js&"
export * from "./GirlMagicBook.vue?vue&type=script&lang=js&"
import style0 from "./GirlMagicBook.vue?vue&type=style&index=0&id=03ad9376&prod&lang=css&"
import style1 from "./GirlMagicBook.vue?vue&type=style&index=1&id=03ad9376&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ad9376",
  null
  
)

export default component.exports